module.exports = __webpack_public_path__ + "static/img/3-1.8fc5666.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-3/3-1.jpg
// module id = 736
// module chunks = 1